import { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Tooltip,
  useMediaQuery,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid2';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import LocationOn from '@mui/icons-material/LocationOn';
import Room from '@mui/icons-material/Room';
import Timeline from '@mui/icons-material/Timeline';
import MediaComponent from './MediaComponent';
import MapComponent from './MapComponent';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectAllDrives,
  selectedDriveVideoURL,
  selectedDriveName,
  selectedDriveId,
} from '../../drive/store/drive.selectors';
import {
  selectAllSigns,
  selectSignsStatus,
  selectSignImages,
  selectEvents,
  selectEventsStatus,
  selectEventsTotal,
  repositionSignsStatus,
  repositionSignsError,
  editDriveNameError,
  editDriveNameStatus,
  nearestGpsData,
  addNewSignStatus,
  addNewSignError,
} from '../store/dashboard.selectors';
import SignChangeComponent from './SignChangeComponent';
import { useTheme } from '@mui/material';
import {
  fetchSignImages,
  deleteEvent,
  changeEvent,
  repositionSigns,
  editDriveName,
  getNearestGPSData,
  resetNearestGPSRecord,
  addNewEvent,
  fetchGPSData,
  fetchEvents,
  fetchSigns,
  resetEventsStateData,
  fetchSelectedEventImageUrl,
} from '../store/dashboard.action';
import {
  setDashboardDriveName,
  setDriveID,
  setDriveVideoURL,
} from '../../drive/store/drive.actions';
import ConfirmDialog from '../../../utils/common/components/MConfirmation';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import {
  StatItem,
  StatValue,
  StatLabel,
  AuthTextField,
  PrimaryButton,
  CancelButton,
} from '../../../utils/common/styles/commonStyles';
import TotalIcon from '@mui/icons-material/Dashboard';
import CapturedEventComponent from './CapturedEventComponent';
import CircularProgress from '@mui/material/CircularProgress';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TableComponent from './TableComponent';
import Skeleton from '@mui/material/Skeleton';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import InfoIcon from '@mui/icons-material/Info';
import InfoComponent from './InfoComponent';
import InfoDialog from '../../../utils/common/components/MInfo';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { saveAs } from 'file-saver';
import { RequestStatus } from '../../../utils/enums';
import LoaderComponent from '../../../utils/common/components/LoaderComponent';
import Breadcrumbs from '../../layout/Breadcrumbs';

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows.heavy,
}));

const IconContainer = styled(Box)(({ theme }) => ({
  height: 80,
  width: 80,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 16px',
}));

const DriveDashboard = () => {
  const theme = useTheme();
  const location = useLocation();
  const dispatch = useDispatch();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const driveName = useSelector(selectedDriveName);
  const driveVideoURL = useSelector(selectedDriveVideoURL);
  const drives = useSelector(selectAllDrives);
  const signs = useSelector(selectAllSigns);
  const signsLoaded = useSelector(selectSignsStatus);
  const signsImages = useSelector(selectSignImages);
  const events = useSelector(selectEvents);
  const eventsStatus = useSelector(selectEventsStatus);
  const eventsTotal = useSelector(selectEventsTotal);
  const moveSignsLoading = useSelector(repositionSignsStatus);
  const moveSignsError = useSelector(repositionSignsError);
  const driveId = useSelector(selectedDriveId);
  const driveEditError = useSelector(editDriveNameError);
  const driveEditLoading = useSelector(editDriveNameStatus);
  const nearestGps = useSelector(nearestGpsData);
  const newSignLoading = useSelector(addNewSignStatus);
  const newSignError = useSelector(addNewSignError);

  const [markers, setMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState({});
  const [images, setImages] = useState([]);
  const [filteredImages, setFilteredImages] = useState([]);
  const [openSignGrid, setOpenSignGrid] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSign, setSelectedSign] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [confirmOpen, setConfirmOpen] = useState({
    replace: false,
    delete: false,
  });
  const [loading, setLoading] = useState(false);
  const [fillerTextDisplay, setFillerTextDisplay] = useState(false);
  const [showFullPath, setShowFullPath] = useState(false);
  const [signRepositioned, setSignRepositioned] = useState(false);
  const [repositionedSigns, setRepositionedSigns] = useState([]);
  const [showZoomToSelected, setShowZoomToSelected] = useState(false);
  const [zoomToSelected, setZoomToSelected] = useState(false);
  const [editdrivename, seteditdrivename] = useState(false);
  const [drivename, setdrivename] = useState('');
  const [isTableView, setIsTableView] = useState(false);
  const [selectedSignsToDelete, setSelectedSignsToDelete] = useState([]);
  const [newDriveName, setNewDriveName] = useState(drivename);
  const [error, setError] = useState('');
  const [navStatus, setNavStatus] = useState(null);
  const [isAddSign, setIsAddSign] = useState(false);
  const [addSignLocation, setAddSignLocation] = useState({ lat: null, lng: null, altitude: null });
  const [capturedFrame, setCapturedFrame] = useState({ url: '', time: null });
  const [showVideo, setShowVideo] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [openInfo, setOpenInfo] = useState({
    open: false,
    activeStep: 0,
  });
  const [openAlert, setOpenAlert] = useState(false);
  const steps = ['Capture sign frame', 'Select sign position', 'Select sign'];
  const saveAlertMessage =
    'The new sign will be added at the end of the list. The sign will be properly sorted the next time the dashboard is opened.';

  const controller = useRef(new AbortController());
  const user = useSelector((state) => state.auth.user);
  const breadcrumbItems = [
    { label: 'Home', path: '/' },
    { label: 'Collections', path: '/collections' },
    { label: 'Drives', path: '/drives' },
    { label: 'Sign Management', path: `/sign-management/${driveId}` },
  ];
  const currentRoleId = Number(
    user?.roleID ||
      user?.roleId ||
      user?.roleid ||
      JSON.parse(localStorage.getItem('user') || '{}')?.roleid
  );
  const shouldShowBreadcrumbs = [1, 2, 3].includes(currentRoleId);

  useEffect(() => {
    // Prefer explicit query param `drive` when present (navigations from Drives table)
    const params = new URLSearchParams(location.search || window.location.search);
    const driveParam = params.get('drive');

    const storedRow = localStorage.getItem('selectedDriveRow');
    let row = null;
    try {
      row = storedRow ? JSON.parse(storedRow) : null;
    } catch (e) {
      row = null;
    }

    const targetDriveId = driveParam || row?.id;
    if (!targetDriveId) return;

    dispatch(setDriveID(targetDriveId));
    dispatch(fetchGPSData(targetDriveId));
    dispatch(setDriveVideoURL(row.video_url || null));

    const selectedDriveNameFromRow = row?.name || row?.drive_name || row?.driveName || '';
    if (selectedDriveNameFromRow && String(row?.id) === String(targetDriveId)) {
      dispatch(setDashboardDriveName(selectedDriveNameFromRow));
    } else if (drives && drives.length > 0) {
      const matchesDriveId = (d) =>
        String(d.id) === String(targetDriveId) || String(d.drive_id) === String(targetDriveId);
      const findDrive = drives.find(matchesDriveId);
      const selectedDriveNameFromList =
        findDrive?.name || findDrive?.drive_name || findDrive?.driveName || '';
      dispatch(setDashboardDriveName(selectedDriveNameFromList));
    } else {
      dispatch(setDashboardDriveName(''));
    }

    dispatch(fetchEvents(targetDriveId, controller.current.signal));
    dispatch(fetchSigns());
  }, [location.search, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetEventsStateData());
    };
  }, [dispatch]);

  useEffect(() => {
    if (Object.keys(selectedMarker).length === 0) setLoading(true);
    else {
      dispatch(fetchSelectedEventImageUrl(selectedMarker.id));
      setLoading(false);
    }
  }, [selectedMarker]);

  useEffect(() => {
    // keep local drivename in sync with selected drive from store
    if (driveName) {
      setdrivename(driveName);
      setNewDriveName(driveName);
    } else {
      setdrivename('');
      setNewDriveName('');
    }
  }, [driveName]);

  useEffect(() => {
    if (location?.state?.status !== undefined) {
      setNavStatus(location.state.status);
    }
  }, [location]);

  useEffect(() => {
    if (!signsLoaded && Array.isArray(signs)) {
      const convertedImages = signs.map((sn) => ({
        imageID: sn.imageID,
        roadStandardCode: sn.roadStandardCode,
        description: sn.name,
        imageFile: sn.imageBucket,
        category: sn.category,
      }));

      setImages(convertedImages);
      setFilteredImages(convertedImages);
    }
  }, [signsLoaded, signs]);

  useEffect(() => {
    if (eventsStatus !== RequestStatus.SUCCEEDED) return;

    if (events.length === 0) {
      setFillerTextDisplay(true);
      return;
    }

    setFillerTextDisplay(false);

    const eventSigns = new Set(events.map((ev) => ev.sign_code));
    eventSigns.delete('sign_code');

    dispatch(fetchSignImages(Array.from(eventSigns)));
  }, [eventsStatus]);

  useEffect(() => {
    if (signsImages && events?.length > 0) {
      const convertedSignImages = signsImages.map((img) => ({
        imageID: img.imageID,
        roadStandardCode: img.roadStandardCode,
        // description: img.description,
        // imageFile: `data:image/jpeg;base64,${btoa(String.fromCharCode(...new Uint8Array(img.imageFile?.data)))}`,
        description: img.name,
        imageFile: img.imageBucket,
        category: img.category,
      }));

      const signsInDrives = events?.map((ev) => {
        return {
          id: ev.id,
          lat: ev.latitude,
          lng: ev.longitude,
          code: ev.sign_code,
          name: ev.sign_name,
          type: ev.sign_type,
          icon:
            convertedSignImages.find((img) => img.roadStandardCode === ev.sign_code)?.imageFile ||
            '',
          position: ev.position || '',
          image: ev.image || '',
          timestamp: ev.captured_time || '',
        };
      });
      setMarkers(signsInDrives);
      setSelectedMarker(signsInDrives[0] || {});
    } else {
      setMarkers([]);
      setSelectedMarker({});
    }
  }, [signsImages, events]);

  useEffect(() => {
    if (editdrivename) {
      setNewDriveName(drivename);
      setError('');
    }
  }, [editdrivename, drivename]);

  useEffect(() => {
    if (isAddSign) {
      setShowVideo(true);
    } else {
      setShowVideo(false);
    }
  }, [isAddSign]);

  useEffect(() => {
    if (capturedFrame.time) {
      dispatch(getNearestGPSData(driveId, capturedFrame.time));
    }
  }, [capturedFrame]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    let searchImages = images.filter(
      (image) =>
        image.roadStandardCode.toLowerCase().includes(e.target.value.toLowerCase()) ||
        image.description.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredImages(searchImages);
  };

  const handleChangeSign = () => {
    setOpenSignGrid(true);
  };

  const handleCancelSearch = () => {
    setSearchTerm('');
    setFilteredImages(images);
  };

  const handleClickMarker = (marker, driveId) => {
    setSelectedMarker(marker);

    if (!driveId) return;

    // load the requested drive data when a marker supplies a drive id
    try {
      dispatch(setDriveID(driveId));
      dispatch(fetchGPSData(driveId));
      dispatch(setDriveVideoURL(driveVideoURL));
      dispatch(fetchEvents(driveId, controller.current.signal));
      dispatch(fetchSigns());
      // try to set name if marker has it (clears stale name if not)
      dispatch(
        setDashboardDriveName(marker?.drive_name || marker?.driveName || marker?.name || '')
      );
    } catch (e) {
      // ignore errors here; MapComponent will still select marker
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const replaceSign = async () => {
    if (!driveId || !selectedMarker?.id || !selectedSign?.imageID) {
      setSnackbar({
        open: true,
        message: 'Please select a sign to replace.',
        severity: 'error',
      });
      return;
    }
    setConfirmOpen({ replace: true, delete: false });
  };

  const handleConfirmReplace = async () => {
    const response = await dispatch(
      changeEvent(
        driveId,
        selectedMarker.id,
        selectedSign.description,
        selectedSign.roadStandardCode,
        selectedSign.category
      )
    );
    if (response?.status === 'success') {
      setSnackbar({
        open: true,
        message: `"${selectedMarker.name}" sign has been replaced by "${selectedSign.description}" in the drive.`,
        severity: 'success',
      });
      setMarkers((prev) =>
        prev.map((m) =>
          m.id === selectedMarker.id
            ? {
                ...m,
                code: selectedSign.roadStandardCode,
                name: selectedSign.description,
                type: selectedSign.category,
                icon: selectedSign.imageFile,
              }
            : m
        )
      );
      setSelectedMarker((prev) => ({
        ...prev,
        code: selectedSign.roadStandardCode,
        name: selectedSign.description,
        type: selectedSign.category,
        icon: selectedSign.imageFile,
      }));
      setOpenSignGrid(false);
      setSelectedSign(null);
    } else {
      setSnackbar({
        open: true,
        message: 'Failed to replace the sign. Please try again.',
        severity: 'error',
      });
    }
    setConfirmOpen({ replace: false, delete: false });
  };

  const deleteSign = async (selectedSignIds = []) => {
    if (
      !driveId &&
      driveId.length === 0 &&
      ((!selectedMarker?.id && selectedMarker.id.length === 0) || selectedSignIds.length === 0)
    ) {
      setSnackbar({
        open: true,
        message: 'Please select a sign to delete.',
        severity: 'error',
      });
      return;
    }
    if (selectedSignIds.length > 0) {
      setSelectedSignsToDelete(selectedSignIds);
    }
    setConfirmOpen({ replace: false, delete: true });
  };

  const handleConfirmDelete = async () => {
    const response = await dispatch(
      deleteEvent(
        driveId,
        selectedSignsToDelete.length > 0 ? selectedSignsToDelete : selectedMarker.id
      )
    );
    if (response?.status === 'success') {
      setSnackbar({
        open: true,
        message:
          selectedSignsToDelete.length > 0
            ? `${selectedSignsToDelete.length} sign(s) have been removed from the drive`
            : `${selectedMarker.name} sign has been removed from the drive`,
        severity: 'success',
      });
      if (selectedSignsToDelete.length > 0) {
        setMarkers((prev) => prev.filter((m) => !selectedSignsToDelete.includes(m.id)));
        setSelectedSignsToDelete([]);
      } else {
        setMarkers((prev) => prev.filter((m) => m.id !== selectedMarker.id));
      }
      setSelectedMarker(markers[0]);
    } else {
      setSnackbar({
        open: true,
        message: 'Failed to delete the sign. Please try again.',
        severity: 'error',
      });
    }
    setConfirmOpen({ replace: false, delete: false });
  };

  const renderSignChangeComponent = () => {
    return (
      <SignChangeComponent
        open={openSignGrid}
        setOpen={setOpenSignGrid}
        images={filteredImages}
        handleSearch={handleSearch}
        searchTerm={searchTerm}
        handleCancelSearch={handleCancelSearch}
        selectedSign={selectedSign}
        setSelectedSign={setSelectedSign}
        replaceSign={replaceSign}
        isAddSign={isAddSign}
        activeStep={activeStep}
      />
    );
  };

  const onMarkerPositionChange = (markerId, newPosition) => {
    if (markers && markers.length) {
      const updatedMarkers = markers.map((marker) =>
        marker.id === markerId ? { ...marker, lat: newPosition.lat, lng: newPosition.lng } : marker
      );
      setSelectedMarker(markers.find((m) => m.id === markerId));
      setSignRepositioned(true);
      setMarkers(updatedMarkers);

      setRepositionedSigns((prev) => {
        const filtered = prev.filter((m) => m.id !== markerId);
        return [...filtered, { id: markerId, lat: newPosition.lat, lng: newPosition.lng }];
      });
    }
  };

  const savePositionChanges = async () => {
    const response = await dispatch(repositionSigns(driveId, repositionedSigns));
    if (response?.status === 'success') {
      setSnackbar({
        open: true,
        message: `Sign positions have been updated successfully.`,
        severity: 'success',
      });
      setRepositionedSigns([]);
      setSignRepositioned(false);
    } else {
      setSnackbar({
        open: true,
        message: moveSignsError || 'Failed to update sign positions. Please try again.',
        severity: 'error',
      });
      setSignRepositioned(true);
    }
  };

  const handleSave = async () => {
    const trimmedName = newDriveName.trim();
    if (!trimmedName) {
      setError('Drive name cannot be empty');
      return;
    }
    if (trimmedName === drivename) {
      setError('New drive name cannot be the same as the current name');
      return;
    }
    setError('');
    const response = await dispatch(editDriveName(driveId, trimmedName));
    if (response?.status === 'success') {
      setSnackbar({
        open: true,
        message: `Drive name updated successfully.`,
        severity: 'success',
      });
      seteditdrivename(false);
      dispatch(setDashboardDriveName(response.data.name));
    } else {
      setSnackbar({
        open: true,
        message: driveEditError || 'Failed to update drive name. Please try again.',
        severity: 'error',
      });
    }
  };

  const exportCSV = () => {
    if (!markers || markers.length === 0) return;
    const header = 'Sign Label,Sign Code,Sign Type,Latitude,Longitude\n';
    const rows = markers
      .map(
        (item) =>
          `"${item.name ?? ''}","${item.code ?? ''}","${item.type ?? ''}",${item.lat ?? ''},${item.lng ?? ''}`
      )
      .join('\n');
    const csvContent = header + rows;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${driveName}.csv`);
  };

  const addSign = async () => {
    const requestData = {
      drive_id: driveId,
      latitude: addSignLocation.lat,
      longitude: addSignLocation.lng,
      frame_url: capturedFrame.url,
      sign_name: selectedSign.description,
      sign_code: selectedSign.roadStandardCode,
      sign_type: selectedSign.category,
      frame_timestamp: capturedFrame.time,
    };
    const response = await dispatch(addNewEvent(requestData));
    if (response?.status === 'success') {
      const newMarkers = [...markers, ...response.data];
      setMarkers(newMarkers);
      setSelectedMarker(response.data[0]);
      cancelAdd();
      setSnackbar({
        open: true,
        message: 'New sign has been added to the drive successfully.',
        severity: 'success',
      });
      setOpenAlert(true);
    } else {
      setSnackbar({
        open: true,
        message: newSignError || 'Failed to add new sign. Please try again.',
        severity: 'error',
      });
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const cancelAdd = () => {
    setIsAddSign(false);
    setCapturedFrame({ url: '', time: null });
    setActiveStep(0);
    setOpenSignGrid(false);
    setAddSignLocation({ lat: null, lng: null, altitude: null });
    setSelectedSign(null);
    dispatch(resetNearestGPSRecord());
  };

  return (
    <Container maxWidth={false} sx={{ py: 0, height: '90%' }}>
      {/* Header */}
      <Grid container spacing={2} mb={1} alignItems="center">
        {isAddSign ? (
          <Grid item size={{ xs: 12 }}>
            <Grid
              container
              sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
            >
              <Grid item size={{ xs: 2 }} sx={{ display: 'flex', alignItems: 'center' }}>
                <Button onClick={cancelAdd} sx={{ mr: 1 }} color="warning">
                  Cancel
                </Button>
                <Button
                  color="inherit"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
              </Grid>

              <Grid item size={{ xs: 8 }}>
                <Stepper
                  activeStep={activeStep}
                  sx={{
                    '& .MuiSvgIcon-root.MuiStepIcon-root.Mui-active': { color: '#00B09B' },
                    '& .MuiSvgIcon-root.MuiStepIcon-root.Mui-completed': { color: 'orange' },
                    '& .MuiStepLabel-label.Mui-active': { color: '#00B09B' },
                  }}
                >
                  {steps.map((label) => {
                    return (
                      <Step key={label} style={{ display: 'flex', gap: 2 }}>
                        <StepLabel>{label}</StepLabel>
                        <InfoIcon
                          sx={{
                            color: '#35c1eb',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            alignSelf: 'center',
                          }}
                          onClick={() =>
                            setOpenInfo({ open: true, activeStep: steps.indexOf(label) })
                          }
                        />
                      </Step>
                    );
                  })}
                </Stepper>
              </Grid>

              <Grid item size={{ xs: 2 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                {newSignLoading ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    <CircularProgress size={20} sx={{ mr: 1 }} color="success" />
                  </Box>
                ) : (
                  <Button
                    onClick={activeStep === steps.length - 1 ? () => addSign() : () => handleNext()}
                    disabled={
                      (activeStep === 0 &&
                        !capturedFrame.url &&
                        !Object.keys(nearestGps).length > 0) ||
                      (activeStep === 1 && (!addSignLocation.lat || !addSignLocation.lng)) ||
                      (activeStep === 2 && !selectedSign)
                    }
                    sx={{
                      color: '#00B09B',
                      animation:
                        (activeStep === 0 &&
                          !capturedFrame.url &&
                          !Object.keys(nearestGps).length > 0) ||
                        (activeStep === 1 && (!addSignLocation.lat || !addSignLocation.lng)) ||
                        (activeStep === 2 && !selectedSign)
                          ? 'none'
                          : 'pulse 2s infinite',
                      '@keyframes pulse': {
                        '50%': {
                          transform: 'scale(1.5)',
                        },
                      },
                    }}
                  >
                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <>
            <Grid item size={{ xs: 12, md: 8 }}>
              {shouldShowBreadcrumbs && <Breadcrumbs items={breadcrumbItems} />}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  overflowX: 'auto',
                  marginTop: 1,
                  marginLeft: 4,
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                <Typography variant={isMdUp ? 'h5' : 'h6'}>{driveName}</Typography>
                <Tooltip title="Edit Drive Name">
                  <IconButton
                    sx={{ ml: 1, color: '#504f05' }}
                    onClick={() => {
                      seteditdrivename(true);
                      setdrivename(driveName);
                    }}
                    size="small"
                  >
                    <EditOutlinedIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Download Excel">
                  <IconButton onClick={exportCSV} size="small">
                    <DescriptionOutlinedIcon
                      sx={{
                        color: '#1D6F42',
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
            <Grid item size={{ xs: 12, md: 4 }} sx={{ textAlign: isMdUp ? 'right' : 'left' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: 5,
                  gap: 2,
                  justifyContent: isMdUp ? 'flex-end' : 'space-between',
                }}
              >
                {!loading && !isAddSign && (
                  <StatItem>
                    <FormControlLabel
                      control={
                        <Switch
                          size="small"
                          checked={isTableView}
                          onChange={() => setIsTableView(!isTableView)}
                          color="primary.rieker"
                        />
                      }
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Typography variant="body2">
                            {isTableView ? 'Sign View' : 'Table View'}
                          </Typography>
                        </Box>
                      }
                    />
                  </StatItem>
                )}
                {!loading && !isTableView && (
                  <Button
                    size="small"
                    variant={isAddSign ? 'contained' : 'outlined'}
                    onClick={() => {
                      setIsAddSign(!isAddSign);
                      setActiveStep(0);
                      setOpenSignGrid(true);
                    }}
                    sx={{
                      textTransform: 'none',
                      borderRadius: '8px',
                      px: 2.3,
                      py: 0.7,
                      color: '#555555',
                      border: '1px solid #667eea',
                      backgroundColor: isAddSign ? 'primary.rieker' : 'transparent',
                      '&:hover': {
                        backgroundColor: 'rgba(102, 126, 234, 0.08)',
                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.15)',
                      },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Typography variant="body2" sx={{ color: 'inherit', fontWeight: 700 }}>
                        Add Sign
                      </Typography>
                    </Box>
                  </Button>
                )}
                <StatItem>
                  <TotalIcon sx={{ fontSize: 20, color: 'secondary.main' }} />
                  <Box display="flex" alignItems="baseline">
                    <StatValue sx={{ color: 'primary.alt' }}>{markers?.length}</StatValue>
                    <StatLabel sx={{ fontSize: '1rem' }}>Captured Signs</StatLabel>
                    {eventsTotal > markers?.length && (
                      <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                        <CircularProgress size={20} sx={{ mr: 1 }} color="success" />
                      </Box>
                    )}
                  </Box>
                </StatItem>
              </Box>
            </Grid>
          </>
        )}
      </Grid>

      <Grid container spacing={2}>
        {/* Thumbnail Card */}
        {!fillerTextDisplay ? (
          eventsStatus === RequestStatus.LOADING ? (
            <Grid container size={{ xs: 12, md: 6 }}>
              <Grid item size={{ xs: 12 }} sx={{ height: '100%' }}>
                <LoaderComponent message="Loading captured signs..." />
              </Grid>
            </Grid>
          ) : (
            <Grid container size={{ xs: 12, md: isTableView ? 7 : 6 }} spacing={2}>
              {isTableView ? (
                <>
                  <TableComponent
                    markers={markers}
                    selectedMarker={selectedMarker}
                    onMarkerChange={handleClickMarker}
                    deleteSign={deleteSign}
                    openSignGrid={openSignGrid}
                    setOpenSignGrid={setOpenSignGrid}
                    filteredImages={filteredImages}
                    handleSearch={handleSearch}
                    searchTerm={searchTerm}
                    handleCancelSearch={handleCancelSearch}
                    selectedSign={selectedSign}
                    setSelectedSign={setSelectedSign}
                    replaceSign={replaceSign}
                  />
                </>
              ) : (
                <>
                  {!isAddSign && (
                    <CapturedEventComponent
                      markers={markers}
                      selectedMarker={selectedMarker}
                      onMarkerChange={handleClickMarker}
                      loading={loading}
                      signsLoaded={signsLoaded}
                      handleChangeSign={handleChangeSign}
                      deleteSign={deleteSign}
                      isAddSign={isAddSign}
                    />
                  )}

                  {/* Change sign card */}
                  {openSignGrid && renderSignChangeComponent()}

                  {/* Primary Photos Section */}
                  <Grid item size={{ xs: 12 }}>
                    <MediaComponent
                      selectedMarker={selectedMarker}
                      driveVideoURL={driveVideoURL}
                      loading={loading}
                      setLoading={setLoading}
                      showVideo={showVideo}
                      setShowVideo={setShowVideo}
                      isAddSign={isAddSign}
                      activeStep={activeStep}
                      capturedFrame={capturedFrame}
                      setCapturedFrame={setCapturedFrame}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )
        ) : (
          <Grid container size={{ xs: 12, md: 6 }}>
            <Grid item size={{ xs: 12 }} sx={{ maxHeight: '100%' }}>
              <StyledCard sx={{ justifyContent: 'center' }}>
                <CardContent sx={{ alignSelf: 'center', justifySelf: 'center' }}>
                  <IconContainer>
                    <SearchOffIcon sx={{ fontSize: 40, color: 'primary.rieker' }} />
                  </IconContainer>
                  <Typography variant="h6">
                    {navStatus === 'PENDING'
                      ? 'Drive is currently in queue for processing'
                      : navStatus === 'PROCESSING'
                        ? 'Drive is currently being processed'
                        : 'There are no signs captured in this drive'}
                  </Typography>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        )}

        {/* Map Section */}
        <Grid container size={{ xs: isTableView ? 12 : 12, md: isTableView ? 5 : 6 }}>
          <Grid item size={{ xs: 12 }} sx={{ maxHeight: '100%' }}>
            <StyledCard
              sx={{
                opacity: isAddSign && activeStep !== 1 && 0.6,
                filter: isAddSign && activeStep !== 1 && 'saturate(0.3) brightness(0.8)',
                pointerEvents: isAddSign && activeStep !== 1 && 'none',
                border: isAddSign && activeStep !== 1 && '1px dashed',
                transition: 'filter 0.3s ease',
                '&::before':
                  isAddSign && activeStep !== 1
                    ? {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: `repeating-linear-gradient(
              45deg,
              rgba(200, 200, 200, 0.4),
              rgba(200, 200, 200, 0.4) 15px,
              rgba(220, 220, 220, 0.3) 15px,
              rgba(220, 220, 220, 0.3) 30px
            )`,
                        backgroundSize: '42px 42px',
                        pointerEvents: 'none',
                        zIndex: 1,
                      }
                    : {},
                '&::after':
                  isAddSign && activeStep !== 1
                    ? {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: '-50%',
                        width: '50%',
                        height: '100%',
                        background:
                          'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)',
                        pointerEvents: 'none',
                        zIndex: 2,
                      }
                    : {},
              }}
            >
              <CardContent sx={{ '&.MuiCardContent-root': { padding: '16px 16px 36px 16px' } }}>
                <Paper>
                  <MapComponent
                    markers={markers}
                    handleClickMarker={handleClickMarker}
                    setSnackbar={setSnackbar}
                    selectedMarker={selectedMarker}
                    showFullPath={showFullPath}
                    setShowFullPath={setShowFullPath}
                    onMarkerPositionChange={onMarkerPositionChange}
                    setShowZoomToSelected={setShowZoomToSelected}
                    zoomToSelected={zoomToSelected}
                    setZoomToSelected={setZoomToSelected}
                    isAddSign={isAddSign}
                    setIsAddSign={setIsAddSign}
                    setAddSignLocation={setAddSignLocation}
                    driveKey={driveId}
                    allowEditMode
                    showSigns
                  />
                </Paper>
                {!isAddSign && (
                  <>
                    <Divider sx={{ mt: 2, mb: 1 }} />
                    <Grid container spacing={2} sx={{ mb: 1 }}>
                      <Grid
                        container
                        size={{ xs: 12, md: 4 }}
                        sx={{ textAlign: 'center', alignItems: 'center' }}
                      >
                        <Grid item xs={12}>
                          <Button
                            variant="outlined"
                            sx={{ color: 'primary.rieker', borderColor: 'border.accent' }}
                            size="small"
                            onClick={() => {
                              if (signRepositioned) {
                                savePositionChanges();
                              } else {
                                if (showZoomToSelected) setZoomToSelected(true);
                                else setShowZoomToSelected(true);
                                setShowFullPath(true);
                              }
                            }}
                            endIcon={
                              moveSignsLoading && signRepositioned ? (
                                <CircularProgress size={20} sx={{ mr: 1 }} color="success" />
                              ) : null
                            }
                          >
                            {signRepositioned
                              ? 'Save Changes'
                              : showZoomToSelected
                                ? 'Zoom to selected sign'
                                : 'Show Full Drive'}
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={2}
                        size={{ xs: 12, md: 8 }}
                      >
                        <Grid item xs={4}>
                          <Chip
                            icon={<LocationOn style={{ color: '#24BD05' }} />}
                            label="Start Point"
                            variant="outlined"
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Chip
                            icon={<Room style={{ color: '#DC1709' }} />}
                            label="End Point"
                            variant="outlined"
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Chip
                            icon={<Timeline style={{ color: 'blue' }} />}
                            label="Path"
                            variant="outlined"
                            size="small"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}
              </CardContent>
            </StyledCard>
          </Grid>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <ConfirmDialog
        header="Replace Sign"
        content={`Are you sure you want to replace the "${selectedMarker?.name}" sign with "${selectedSign?.description}"?`}
        open={confirmOpen.replace}
        setOpen={setConfirmOpen}
        onConfirm={handleConfirmReplace}
      />

      <ConfirmDialog
        header="Delete sign"
        content={
          selectedSignsToDelete.length > 0
            ? `Are you sure you want to delete ${selectedSignsToDelete.length} sign(s) from this drive?`
            : `Are you sure you want to delete the "${selectedMarker?.name}" sign from this drive?`
        }
        open={confirmOpen.delete}
        setOpen={setConfirmOpen}
        onConfirm={handleConfirmDelete}
      />

      <Dialog open={editdrivename} onClose={() => seteditdrivename(false)} fullWidth maxWidth="sm">
        <DialogTitle>Edit Drive Name</DialogTitle>
        <DialogContent>
          {driveEditLoading ? (
            <Skeleton width="100%" height={50} sx={{ mb: 2 }} />
          ) : (
            <AuthTextField
              label="Enter new drive name"
              type="text"
              fullWidth
              disabled={driveEditLoading}
              value={newDriveName}
              sx={{ mt: 2 }}
              onChange={(e) => {
                setNewDriveName(e.target.value);
                if (error) setError('');
              }}
              onKeyDown={async (e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  await handleSave();
                }
              }}
              error={!!error}
              helperText={error}
            />
          )}
        </DialogContent>
        <DialogActions>
          {driveEditLoading ? (
            <Skeleton width="100px" height={50} sx={{ m: 2 }} />
          ) : (
            <CancelButton onClick={() => seteditdrivename(false)}>Cancel</CancelButton>
          )}
          {driveEditLoading ? (
            <CircularProgress size={24} sx={{ m: 2 }} color="success" />
          ) : (
            <PrimaryButton
              onClick={handleSave}
              variant="contained"
              disabled={newDriveName.trim() === drivename.trim() || driveEditLoading}
            >
              Save
            </PrimaryButton>
          )}
        </DialogActions>
      </Dialog>

      <InfoComponent open={openInfo} setOpen={setOpenInfo} activeStep={activeStep} />

      <InfoDialog
        open={openAlert}
        setOpen={setOpenAlert}
        header="Information"
        content={saveAlertMessage}
      />
    </Container>
  );
};

export default DriveDashboard;
